export const ROUTES = {
  // Root routes
  ROOT: "/",
  HOME: "/",

  // Feature routes
  SUPPLEMENT_DATA: "/supplement-data",
  WEBCHAT: "/webchat",

  // Campaign Management routes
  CAMPAIGN_MANAGEMENT: "/campaign-management",
  CAMPAIGN_CREATE: "/campaign-management/create",
  CAMPAIGN_VIEW: "/campaign-management/:id",
  CAMPAIGN_TPMO: "/campaign-management/tpmo",

  // Candidate Outreach routes
  PRESCREENING: "/candidate-outreach",
  PRESCREENING_EDIT: "/candidate-outreach/edit/:id",
  PRESCREENING_DETAILS: "/candidate-outreach/details/:id",

  // Testing routes
  TESTING_CANDIDATE_MGMT: "/testing/candidate-mgmt",
  TESTING_CANDIDATE_MGMT_CREATE: "/testing/candidate-mgmt/create",
  TESTING_CANDIDATE_MGMT_EDIT: "/testing/candidate-mgmt/edit/:id",

  TESTING_JOB_ORDER_MGMT: "/testing/job-order-mgmt",
  TESTING_JOB_ORDER_CREATE: "/testing/job-order-mgmt/create",
  TESTING_JOB_ORDER_EDIT: "/testing/job-order-mgmt/edit/:id",
  TESTING_JOB_ORDER_RECIPIENTS: "/testing/job-order-mgmt/recipients/:id",

  TESTING_VIEW_SQS: "/testing/view-sqs",

  // Sender Persona routes
  SENDER_PERSONA: "/sender-persona",
  SENDER_PERSONA_FORM: "/sender-persona/form",
  SENDER_PERSONA_FORM_EDIT: "/sender-persona/form/:id",
  SENDER_PERSONA_DETAILS: "/sender-persona/details/:id",

  // Analytics routes
  ANALYTICS: "/analytics",
  ANALYTICS_TRANSACTION_TRACKING: "/analytics/transaction-tracking",
  ANALYTICS_FAILURE_TRANSACTIONS: "/analytics/failure-transactions",

  // Knowledge Base Setup routes
  KNOWLEDGE_BASE_SETUP: "/knowledge-base-setup",
  FILE_MANAGEMENT: "/file-management",

  // Communication Integration routes
  COMMUNICATION_INTEGRATION: "/communication-integration",
  COMMUNICATION_INTEGRATION_CREATE: "/communication-integration/create",
  COMMUNICATION_INTEGRATION_EDIT: "/communication-integration/edit/:id",

  // Compliance & Quiet Hours routes
  COMPLIANCE_QUIET_HOURS: "/compliance-quiet-hours",

  // Constants Management routes
  CONSTANTS_MANAGEMENT: "/constants-management",

  // Role Management routes
  ROLE_MANAGEMENT: "/role-management",
} as const;

/**
 * Route Builder Functions
 * 
 * Helper functions to generate routes with parameters.
 * These provide type-safe route generation and ensure consistency.
 */

/**
 * Generate campaign view route with ID
 */
export const getCampaignViewRoute = (id: string | number): string => {
  return `/campaign-management/${id}`;
};

/**
 * Generate campaign details route with ID (alias for getCampaignViewRoute)
 */
export const getCampaignDetailsRoute = (id: string | number): string => {
  return `/campaign-management/${id}`;
};

/**
 * Generate candidate outreach edit route with ID
 */
export const getPrescreeningEditRoute = (id: string | number): string => {
  return `/candidate-outreach/edit/${id}`;
};

/**
 * Generate candidate outreach details route with ID
 */
export const getPrescreeningDetailsRoute = (id: string | number): string => {
  return `/candidate-outreach/details/${id}`;
};

/**
 * Generate testing candidate management edit route with ID
 */
export const getTestingCandidateMgmtEditRoute = (id: string | number): string => {
  return `/testing/candidate-mgmt/edit/${id}`;
};

/**
 * Generate testing job order edit route with ID
 */
export const getTestingJobOrderEditRoute = (id: string | number): string => {
  return `/testing/job-order-mgmt/edit/${id}`;
};

/**
 * Generate testing job order recipients route with ID
 */
export const getTestingJobOrderRecipientsRoute = (id: string | number): string => {
  return `/testing/job-order-mgmt/recipients/${id}`;
};

/**
 * Generate sender persona form route (for create)
 */
export const getSenderPersonaFormRoute = (): string => {
  return `/sender-persona/form`;
};

/**
 * Generate sender persona form route with ID (for edit)
 */
export const getSenderPersonaEditRoute = (id: string | number): string => {
  return `/sender-persona/form/${id}`;
};

/**
 * Generate sender persona details route with ID
 */
export const getSenderPersonaDetailsRoute = (id: string | number): string => {
  return `/sender-persona/details/${id}`;
};

/**
 * Generate file management route with KB info ID
 */
export const getFileManagementRoute = (id: string | number): string => {
  return `/file-management?id=${id}`;
};
